// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-section {
  background: #FFFFFF;
  padding: 96px 0;
}

.legal-inner {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 56px;
}

.legal-title {
  font-size: 34px;
  font-weight: 800;
  color: var(--ink);
  margin: 0 0 44px;
}

.legal-block {
  margin-bottom: 36px;
}

.legal-h2 {
  font-size: 18px;
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 14px;
}

.legal-p {
  font-size: 15px;
  line-height: 1.75;
  color: var(--body);
  margin: 0 0 12px;
}

.legal-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 15px;
  line-height: 1.8;
  color: var(--body);
}

.legal-list li {
  padding: 3px 0;
}

.legal-link {
  color: #EE5B43;
  font-weight: 600;
  text-decoration: none;
}

.legal-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-inner {
    padding: 0 24px;
  }

  .legal-title {
    font-size: 28px;
  }
}
@media (min-width: 1850px) {
  .legal-inner {
    max-width: 1200px;
    padding: 0 100px;
  }
 
  .legal-title {
    font-size: 42px;
    margin-bottom: 56px;
  }
 
  .legal-block {
    margin-bottom: 48px;
  }
 
  .legal-h2 {
    font-size: 24px;
    margin-bottom: 18px;
  }
 
  .legal-p,
  .legal-list {
    font-size: 18px;
    line-height: 1.9;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/MentionsLegales/MentionsLegales.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".legal-section {\n  background: #FFFFFF;\n  padding: 96px 0;\n}\n\n.legal-inner {\n  max-width: 860px;\n  margin: 0 auto;\n  padding: 0 56px;\n}\n\n.legal-title {\n  font-size: 34px;\n  font-weight: 800;\n  color: var(--ink);\n  margin: 0 0 44px;\n}\n\n.legal-block {\n  margin-bottom: 36px;\n}\n\n.legal-h2 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--ink);\n  margin: 0 0 14px;\n}\n\n.legal-p {\n  font-size: 15px;\n  line-height: 1.75;\n  color: var(--body);\n  margin: 0 0 12px;\n}\n\n.legal-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--body);\n}\n\n.legal-list li {\n  padding: 3px 0;\n}\n\n.legal-link {\n  color: #EE5B43;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.legal-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .legal-inner {\n    padding: 0 24px;\n  }\n\n  .legal-title {\n    font-size: 28px;\n  }\n}\n@media (min-width: 1850px) {\n  .legal-inner {\n    max-width: 1200px;\n    padding: 0 100px;\n  }\n \n  .legal-title {\n    font-size: 42px;\n    margin-bottom: 56px;\n  }\n \n  .legal-block {\n    margin-bottom: 48px;\n  }\n \n  .legal-h2 {\n    font-size: 24px;\n    margin-bottom: 18px;\n  }\n \n  .legal-p,\n  .legal-list {\n    font-size: 18px;\n    line-height: 1.9;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
